import React, { useState } from "react";
import livroReclamacoes from "../assets/livro_reclamacoes.png";
import config from "../config";
import packageJson from "../../package.json";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FaFacebookSquare } from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const version = packageJson.version;

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      toast.error("Por favor, insere um e-mail válido.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(
        `${config.baseURL}/api/DestinatariosNewsletter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(email),
        },
      );

      if (!response.ok) {
        if (response.status === 409) {
          const errorData = await response.json();
          toast.error(errorData?.message || "Este e-mail já está subscrito.");
        } else {
          toast.error("Erro ao subscrever. Tente novamente.");
        }
        return;
      }

      await response.json();
      toast.success(
        "Foi enviado um e-mail para confirmar a sua subscrição. Por favor verifique a sua caixa de correio e spam!",
        {
          autoClose: false, // Isso impede que o toast desapareça automaticamente
        },
      );
      setEmail(""); // limpar campo
    } catch (error) {
      toast.error("Erro ao enviar o e-mail. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const isEmailValid = /\S+@\S+\.\S+/.test(email);

  return (
    <footer className="bg-orange-600 text-white px-6 py-8 mt-[100px]">
      <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-start gap-8">
        {/* Esquerda */}
        <div className="flex-1 min-w-[250px]">
          <p className="text-sm mb-2">
            <span className="font-bold">Rua Infantaria Quinze, 9 E</span>,
            2300-585 Tomar
          </p>
          <p className="text-sm mb-2">
            <strong className="font-bold">Tel.:</strong> 249 312 326 &nbsp;
            <strong className="font-bold">Fax:</strong> 249 323 237
          </p>
          <p className="text-sm">
            <strong className="font-bold">E-mail:</strong> geral@scmt.pt
          </p>
          <div className="mt-4">
            <a
              href="https://www.facebook.com/scmtomar/"
              target="_blank"
              rel="noopener noreferrer"
              title="Facebook"
              className="inline-flex items-center gap-2 text-white hover:text-gray-100 transition-colors"
            >
              <FaFacebookSquare size={24} />
              <span className="text-sm">Segue-nos no Facebook</span>
            </a>
          </div>
        </div>

        {/* Centro */}
        <div className="flex-1 min-w-[250px] text-center">
          <h4 className="uppercase text-sm font-semibold mb-2">Newsletter</h4>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="E-mail..."
              value={email}
              onChange={handleEmailChange}
              className="w-full max-w-xs px-4 py-2 rounded text-black mb-2"
              required
            />
            <button
              type="submit"
              className={`bg-black text-white px-4 py-2 text-xs uppercase rounded hover:bg-gray-800 ${
                !isEmailValid || isSubmitting
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
              disabled={!isEmailValid || isSubmitting}
            >
              {isSubmitting ? "Aguarde..." : "Subscrever"}
            </button>
          </form>
        </div>

        {/* Direita */}
        <div className="flex-1 min-w-[250px] flex flex-col items-end text-right">
          <a
            href="https://www.livroreclamacoes.pt"
            target="_blank"
            rel="noopener noreferrer"
            title="Livro de Reclamações"
          >
            <img
              src={livroReclamacoes}
              alt="Livro de Reclamações"
              className="h-24 object-contain"
            />
          </a>
          <div className="mt-6 text-sm text-white">
            <Link
              to="/canal-denuncias"
              className="hover:text-gray-100 underline transition-colors"
            >
              Canal de Denúncias
            </Link>{" "}
            |{" "}
            <Link
              to="/prevencao-corrupcao"
              className="hover:text-gray-100 underline transition-colors"
            >
              Prevenção de Corrupção
            </Link>
          </div>
        </div>
      </div>

      <p className="text-sm mt-6 text-center">
        &copy; {new Date().getFullYear()} SANTA CASA DA MISERICÓRDIA DE TOMAR -{" "}
        {version}
      </p>

      <div className="text-center mt-4">
        <p className="text-sm">
          Desenvolvido por{" "}
          <Link
            to="/developers"
            className="text-white hover:text-gray-100 underline transition-colors"
          >
            IPT
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
